import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkBadge, UitkBadgeSize, UitkBadgeTheme } from "uitk-react-badge";

import { ProductTypeContext, ProductTypeDescriptionContext } from "components/flexComponents/TopCities/TopCities";
import { ProductType, ProductIconType } from "components/flexComponents/TopCities/utils/topCitiesEnums";

const ProductIcon = (props: { index: number; cardType: string }) => {
  const { index, cardType } = props;
  const productType = React.useContext(ProductTypeContext);
  const productTypeDescription = React.useContext(ProductTypeDescriptionContext);
  const { formatText } = useLocalization();

  const iconName = {
    hotels: ProductIconType.LOB_HOTELS,
    flights: ProductIconType.LOB_FLIGHTS,
    cars: ProductIconType.LOB_CARS,
    vacation_rentals: ProductIconType.LOB_VACATION_RENTALS,
    accommodations: ProductIconType.LOB_VACATION_RENTALS,
  };

  const iconDescription = {
    hotels: formatText("topCities.hotels"),
    flights: formatText("topCities.flights"),
    cars: formatText("topCities.cars"),
    vacation_rentals: formatText("topCities.vacationRentals"),
    accommodations: productTypeDescription,
  };

  if (productType === ProductType.PACKAGES) {
    return (
      <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
        <UitkLayoutFlex>
          <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
            <UitkIcon
              name={ProductIconType.LOB_FLIGHTS}
              id={`top-cities-${cardType}-${ProductType.FLIGHTS}-${index}`}
              title={iconDescription.flights}
              description={iconDescription.flights}
              size={UitkIconSize.SMALL}
            />
          </UitkBadge>

          <UitkSpacing margin={{ inlinestart: "two" }}>
            <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
              <UitkIcon
                name={ProductIconType.LOB_HOTELS}
                id={`top-cities-${cardType}-${ProductType.HOTELS}-${index}`}
                title={iconDescription.hotels}
                description={iconDescription.hotels}
                size={UitkIconSize.SMALL}
              />
            </UitkBadge>
          </UitkSpacing>
        </UitkLayoutFlex>
      </UitkLayoutPosition>
    );
  }

  return (
    <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
      <UitkBadge theme={UitkBadgeTheme.NOTIFICATION_2} size={UitkBadgeSize.LARGE}>
        <UitkIcon
          name={iconName[productType]}
          id={`top-cities-${cardType}-${productType}-${index}`}
          title={iconDescription[productType]}
          description={iconDescription[productType]}
          size={UitkIconSize.SMALL}
        />
      </UitkBadge>
    </UitkLayoutPosition>
  );
};

export default ProductIcon;
